export const isFullStatic = false
export const staticPath = "/root/project/frontend/.nuxt/static-json"
export const publicPath = "https://frontenddev.builtin.com/ad8d303eaedbc20307360efe59364310cd55d968/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"